import { cn } from '@/lib/ui/style-helpers'

type IntegrationLogoProps = {
  /** Icon URL as served by the backend (`Source.imgUrl` / `Integration.iconUrl`). */
  src: string
  name: string
  size?: 'small' | 'default'
  /** Set when the name is already visible beside the logo. */
  decorative?: boolean
  className?: string
}

/**
 * An integration's logo, contained in a fixed square. Some of the served icons
 * are wide wordmarks (ziphq is 2.06:1), which object-cover crops to a sliver and
 * the default fill squashes.
 */
export const IntegrationLogo = ({
  src,
  name,
  size = 'small',
  decorative,
  className,
}: IntegrationLogoProps) => (
  <img
    src={src}
    alt={decorative ? '' : name}
    className={cn('shrink-0 object-contain', size === 'default' ? 'size-5' : 'size-4', className)}
  />
)
